import { isBefore, isSameDay, startOfDay } from "date-fns";
import { TICKET_STATUS } from "pages/AccountSettlementHistoryOrderId/constants/TicketStatus";

import type { TimeStamp } from "pages/AccountSettlementHistoryOrderId/types/TimeStamp";

type TicketStatus = (typeof TICKET_STATUS)[keyof typeof TICKET_STATUS];

export const getTicketStatus = (eventDateTime: TimeStamp): TicketStatus => {
  const today = startOfDay(new Date());
  const eventDate = startOfDay(new Date(eventDateTime.seconds * 1000));

  if (isBefore(today, eventDate)) {
    return TICKET_STATUS.BEFORE_OPENING;
  } else if (isSameDay(today, eventDate)) {
    return TICKET_STATUS.ON_GOING;
  } else {
    return TICKET_STATUS.ENDED;
  }
};
